import {
    createSlice
}
    from '@reduxjs/toolkit';

const initialState = {
    page: 0,
    title: "",
    menu: {
        expanded: false
    },
    product: "ATS"
};

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        updateLayout: (state, action) => {
            const { page, title, product } = action.payload
            state.page = page;
            state.title = title;
            if(product){
                state.product = product;
            }
        },
        updateMenuToggle: (state) => {
            state.menu.expanded = !state.menu.expanded;
        },
        updateProduct: (state, action) => {
            const { product } = action.payload;
            state.product = product;
        },
    }
});

export const { updateLayout, updateMenuToggle, updateProduct } = layoutSlice.actions;

export default layoutSlice.reducer

export const selectLayoutDetail = state => {
    return {
        title: state.layout.title,
        page: state.layout.page
    }
}

export const selectMenuExpanded = state => state.layout.menu.expanded;

export const selectProduct = state => state.layout.product;